// extracted by mini-css-extract-plugin
export default {"field":"field_field__07KIA","textAreaLabel":"field_textAreaLabel__DUAgN","fieldInput":"field_fieldInput__aQCl5","textAreaSpan":"field_textAreaSpan__y7ONr"};